// Base de la API. En producción queda vacía a propósito: nginx reenvía /api al backend,
// de modo que el sitio y la API comparten dominio (sin CORS ni contenido mixto).
// Solo se define REACT_APP_BACKEND_URL si la API vive en otro dominio.
const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

export const apiUrl = (path) => `${BASE}${path}`;
